import { AlertColor } from '@mui/material'
import { SNACKBAR_DISPLAY, SNACKBAR_HIDE } from '../../utils/constants'

export const displaySnackbar = (severity: AlertColor, message: string) => (dispatch: any) => {
    dispatch({
        type: SNACKBAR_DISPLAY,
        payload: {
            severity,
            message,
        },
    })
}

export const hideSnackbar = () => (dispatch: any) => {
    dispatch({
        type: SNACKBAR_HIDE,
    })
}
